import { Flex, Input, Space, Spacing } from '@billy/design-system'
import { useState } from 'react'

export const Scopes = () => {
  const [filter, setFilter] = useState('')
  const scopes = window.Billy.scopes as string[]

  const filteredScopes = scopes.filter((scope) => scope.includes(filter))

  return (
    <Flex flexDirection="column" gap={Spacing.S16}>
      <Space size="s2" />
      <Input placeholder="Search scopes" value={filter} onChange={(e) => setFilter(e.target.value)} />

      {filteredScopes.map((scope) => (
        <div key={scope}>{scope}</div>
      ))}
      {filteredScopes.length === 0 && <div>No scopes found</div>}
    </Flex>
  )
}
